<template>
  <div class="headerWarp">
    <div class="headerTime">
      <!-- <a-button @click="goHomeHandle"></a-button> -->
      <img @click="goHomeHandle" src="~@/assets/bigusers/largeScreen/homePage.png" />
      <span>{{ date | formatDate }}</span>
    </div>
    <div class="headerTitle">
      <img src="~@/assets/myImg/title-01.png" />
      <span class="DataTitle">水厂智能化系统</span>
    </div>
    <div class="weatherWarp">
      <span>{{ alarme.text }} {{ alarme.temp }}°C
        风向：{{ alarme.windDir }}
      </span>
      <img style="width: 32px; height: 32px; margin-left: 30px;" @click="goWorkTable"
        src="~@/assets/bigusers/largeScreen/workTable.png" />
      <img class="fullImg" @click="quanping" :src="'/iconImg/' + (a % 2 == 1 ? 'h_h_min' : 'h_h_max') + '.png'" />
    </div>
  </div>
</template>
<script>
var padDate = function (value) {
  return value < 10 ? '0' + value : value
}
export default {
  name: 'waterHeader',
  data () {
    return {
      a: 0,
      date: new Date(),
      alarme: {
        temp: '',
        text: '',
        windDir: '',
      }
    }
  },
  filters: {
    formatDate: function (value) {
      var date = new Date(value)
      var year = date.getFullYear()
      var month = padDate(date.getMonth() + 1)
      var day = padDate(date.getDate())
      var hours = padDate(date.getHours())
      var minutes = padDate(date.getMinutes())
      var seconds = padDate(date.getSeconds())
      // 整理并返回
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    }
  },
  mounted: function () {
    var _this = this // 指向this 变量作用域一致;
    this.timer = setInterval(function () {
      _this.date = new Date() // 修改date
    }, 1000)
  },
  created () {
    this.getOnlineAlarme()
  },
  methods: {
    quanping () {
      this.a++
      this.a % 2 == 1 ? this.enterfullscreen() : this.exitfullscreen()
      console.log(this.a)
    },
    getOnlineAlarme () {
      this.$http.get('/pipe-network/report/chart/get-weather').then(res => {
        this.alarme = res.data.now
      })
    },
    enterfullscreen () {
      //进入全屏
      var docElm = document.documentElement
      //W3C
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      }
      //FireFox
      else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      }
      //Chrome等
      else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      }
      //IE11
      else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    },
    //退出全屏
    exitfullscreen () {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    },
    goHomeHandle () {
      this.$router.push('/')
    },
    goWorkTable () {
      // this.$router.push('/')
      this.$router.push('/Intelligent-water-plant/Equipment-management')
    }
  }
}
</script>

<style lang="less" scoped>
.headerWarp {
  max-width: 100%;
  width: 100vw;
  height: 58px;
  opacity: 0.95;
  background: rgba(6, 13, 42, 0.75);
  border-bottom: 2px solid rgba(16, 192, 255, 0.25);
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  line-height: 58px;

  .headerTime {
    font-family: MicrosoftYaHeiSemibold;
    font-size: 20px;
    color: #ffffff;
    font-weight: 600;
    display: flex;
    align-items: center;

    img {
      height: 32px;
      width: 32px;
      cursor: pointer;
    }

    span {
      margin-left: 12px;
    }
  }

  .headerTitle {
    // z-index: 1000;
    position: relative;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 36px;
    color: #10c0ff;
    text-align: center;
    font-weight: 600;
    text-align: center;

    .DataTitle {
      letter-spacing: 8px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      display: block;
    }

    img {
      position: relative;
      z-index: 1000;
      width: 870px;
      height: 80px;
    }
  }

  .weatherWarp {
    display: flex;
    align-items: center;

    span {
      font-family: MicrosoftYaHeiSemibold;
      font-size: 20px;
      color: #ffffff;
      display: inline-block;
      font-weight: 600;
    }

    .imgWeather {
      width: 18px;
      height: 18px;
      margin-right: 12px;
      // color: red;
      background-color: white;
    }

    .fullImg {
      width: 26px;
      height: 26px;
      margin-left: 12px;
      cursor: pointer;
    }
  }
}
</style>